/**
 * API de autenticación
 */
import client, { API_URL } from './client';

export const authApi = {
  login: (username, password) =>
    client.post('/auth/login', { username, password }),

  refresh: (refreshToken) =>
    client.post('/auth/refresh', { refresh_token: refreshToken }),

  logout: () =>
    client.post('/auth/logout'),

  getMe: () =>
    client.get('/auth/me'),

  changePassword: (currentPassword, newPassword) =>
    client.put('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    }),

  // OAuth URLs
  getGoogleAuthUrl: () => `${API_URL}/api/auth/oauth/google`,
  getMicrosoftAuthUrl: () => `${API_URL}/api/auth/oauth/microsoft`,
};
